import _ from 'lodash';
import configuration from '@price-point/configuration';

export default function getUrl(name: string): string {
  if (typeof window === 'undefined') {
    if (configuration('USE_EXTERNAL_URL') === 'true') {
      return 'http://api.pricepointmoves.com';
    }
  }

  return `http://${_.kebabCase(name)}.default.svc.cluster.local`;
}
